<template>
  <div class="edit-container" @click="shortcutInit()">
    <a
      v-if="editText"
      href="javascript:;"
      class="cancel-edit"
      @click="cancelEdit()"
    >取消</a>

    <div class="edit-story" @click.stop="">
      <ul class="role-site" v-if="$store.state.setRoleSiteDom && isOPenshortCut() && !visualEdit">
        <li class="option" :class="{'act': roleSite === 0}" @click="setRoleSite(0)">左</li>
        <li class="option" :class="{'act': roleSite === 1}" @click="setRoleSite(1)">右</li>
      </ul>
      <edit-story-tool @openWidget="editWidget" :moodType="moodType"></edit-story-tool>

      <mt-popup v-model="shortcut.role" position="bottom">
        <ul class="role-site" v-if="$store.state.setRoleSiteDom && shortcut.role">
          <li class="option" :class="{'act': roleSite === 0}" @click="setRoleSite(0)">左</li>
          <li class="option" :class="{'act': roleSite === 1}" @click="setRoleSite(1)">右</li>
        </ul>
        <edit-story-tool @openWidget="editWidget" :moodType="moodType"></edit-story-tool>
        <ul class="edit-detail stage-roles clearfix" ref="roleWrapper">
          <li v-for="role in roleData" :key="role.id" class="role-list"
              @click="selectRole(commonMethods.getRoleCover(role), role)"
              :class="{'leading-sign': roleStatus(role, 'leading'), 'costar-sign': roleStatus(role, 'costar')}">
            <template v-if="roleStatus(role, 'leading')">
              <img :src="commonMethods.getRoleCover(role)" class="role-pic">
              <p class="role-name leading elli">{{role.name}}</p>
            </template>
            <template v-else-if="roleStatus(role, 'costar')">
              <img :src="commonMethods.getRoleCover(role)" class="role-pic">
              <p class="role-name costar elli">{{role.name}}</p>
            </template>
            <template v-else-if="roleStatus(role, 'aside')">
              <img src="../../static/image/aside.jpg" alt="旁白" class="role-pic">
              <div class="role-name aside elli">旁白</div>
            </template>
          </li>
          <li class="role-list" @click="editWidget('addRole')">
            <img src="../../static/image/add_role.png" alt="配角" class="role-pic">
            <p class="role-name costar elli">配角</p>
          </li>
        </ul>
      </mt-popup>

      <mt-popup v-model="shortcut.media" position="bottom">
        <ul class="role-site" v-if="$store.state.setRoleSiteDom && shortcut.media && !visualEdit">
          <li class="option" :class="{'act': roleSite === 0}" @click="setRoleSite(0)">左</li>
          <li class="option" :class="{'act': roleSite === 1}" @click="setRoleSite(1)">右</li>
        </ul>
        <edit-story-tool @openWidget="editWidget" :moodType="moodType"></edit-story-tool>
        <ul class="edit-detail multimedia clearfix">
          <li class="media-list" @click="editWidget('chapter', 18)">
            <i class="icon plot-jump"></i>
            <p>剧情跳转</p>
          </li>
          <li v-if="parrent.createPattern !== 2" class="media-list" @click="editWidget(parrent.createPattern === 1? 'mood': 'emoji', 19)">
            <i class="icon emoji"></i>
            <p>表情</p>
          </li>
          <li class="media-list" @click="addDifItem()">
            <i class="icon options"></i>
            <p>对话选项</p>
          </li>
          <li class="media-list" @click="openMaLib(bgmMaLib, 21)">
            <i class="icon bgm"></i>
            <p>背景音乐</p>
          </li>
          <li class="media-list" @click="openMaLib(bgMaLib, 22)">
            <i class="icon bg"></i>
            <p>背景图片</p>
          </li>
          <li class="media-list">
            <i class="icon num" @click="cutSetting('num', true)"></i>
            <p>数值设定</p>
          </li>
          <li class="media-list">
            <i class="icon condition" @click="cutSetting('condition', true)"></i>
            <p>条件设定</p>
          </li>

        </ul>
      </mt-popup>

      <mt-popup v-model="shortcut.emoji" position="bottom" class="emojiWrapper">
        <ul class="role-site" v-if="$store.state.setRoleSiteDom && shortcut.emoji && !visualEdit">
          <li class="option" :class="{'act': roleSite === 0}" @click="setRoleSite(0)">左</li>
          <li class="option" :class="{'act': roleSite === 1}" @click="setRoleSite(1)">右</li>
        </ul>
        <div class="edit-detail emoji">
          <template>
            <ul class="clearfix"
                v-infinite-scroll="loadMore"
                infinite-scroll-disabled="dataLoading"
                infinite-scroll-distance="0"
                infinite-scroll-immediate-check="false">
              <template v-if="maData.length > 0">
                <li v-for="item in maData"
                    @click="sendMsg('emoji', cdnres +item.rs_url.substr(0,2)+'/'+ item.rs_url, item, 23)"
                    class="list">
                  <img :src="cdnres +item.rs_url.substr(0,2)+'/'+ item.rs_url" class="pic">
                </li>
              </template>
              <template v-else>
                <li v-if="!isLoading">没有数据</li>
              </template>
            </ul>
          </template>
          <template v-if="isLoading">
            <div class="loading">
              <mt-spinner type="double-bounce" color="#ff6600"></mt-spinner>
            </div>
          </template>
        </div>
      </mt-popup>
      <mt-popup v-model="$store.state.editMsgEmoji" position="bottom" class="emojiWrapper">
        <ul class="role-site" v-if="$store.state.setRoleSiteDom && $store.state.editMsgEmoji && !visualEdit">
          <li class="option" :class="{'act': roleSite === 0}" @click="setRoleSite(0)">左</li>
          <li class="option" :class="{'act': roleSite === 1}" @click="setRoleSite(1)">右</li>
        </ul>
        <div class="edit-detail emoji">
          <template>
            <ul class="clearfix"
                v-infinite-scroll="loadMore"
                infinite-scroll-disabled="dataLoading"
                infinite-scroll-distance="0"
                infinite-scroll-immediate-check="false">
              <template v-if="maData.length > 0">
                <li v-for="item in maData"
                    @click="sendMsg('emoji', cdnres +item.rs_url.substr(0,2)+'/'+ item.rs_url, item, 24)"
                    class="list">
                  <img :src="cdnres +item.rs_url.substr(0,2)+'/'+ item.rs_url" class="pic">
                </li>
              </template>
              <template v-else>
                <li v-if="!isLoading">没有数据</li>
              </template>
            </ul>
          </template>
          <template v-if="isLoading">
            <div class="loading">
              <mt-spinner type="double-bounce" color="#ff6600"></mt-spinner>
            </div>
          </template>
        </div>
      </mt-popup>
      <mt-popup v-model="shortcut.mood" position="bottom">
        <ul class="role-site" v-if="$store.state.setRoleSiteDom && shortcut.mood && !visualEdit">
          <li class="option" :class="{'act': roleSite === 0}" @click="setRoleSite(0)">左</li>
          <li class="option" :class="{'act': roleSite === 1}" @click="setRoleSite(1)">右</li>
        </ul>
        <edit-story-tool @openWidget="editWidget" :moodType="moodType"></edit-story-tool>
        <div class="edit-detail mood">
          <ul class="clearfix">
            <li v-if="moodSwitch.normal" class="list">
              <i
                class="ico mood0"
                :class="{'act': moodType === 0}"
                @click="setMood(moodList[0].type, 0)"
              >
              </i>
              <p class="name" v-text="moodList[0].name"></p>
            </li>
            <li v-if="moodSwitch.happy" class="list">
              <i
                class="ico mood1"
                :class="{'act': moodType === 1}"
                @click="setMood(moodList[1].type, 1)"
              >
              </i>
              <p class="name" v-text="moodList[1].name"></p>
            </li>
            <li v-if="moodSwitch.sad" class="list">
              <i
                class="ico mood2"
                :class="{'act': moodType === 2}"
                @click="setMood(moodList[2].type, 2)"
              >
              </i>
              <p class="name" v-text="moodList[2].name"></p>
            </li>
            <li v-if="moodSwitch.angry" class="list">
              <i
                class="ico mood3"
                :class="{'act': moodType === 3}"
                @click="setMood(moodList[3].type, 3)"
              >
              </i>
              <p class="name" v-text="moodList[3].name"></p>
            </li>
          </ul>
        </div>
      </mt-popup>
    </div>

    <conditions-set @close="cutSetting('condition', false)"></conditions-set>
    <numerical-setup @close="cutSetting('num', false)"></numerical-setup>

  </div>
</template>
<script>
  import Vue from 'vue';
  import {mapState} from 'vuex';
  import {Toast} from 'mint-ui';
  import store from '../store/store';
  import {GameData} from '../store/GameData';
  import {MaType, MaLib} from '../store/MaLib';
  import audioPlayer from '../utils/AudioPlayer';
  import {ProjectData} from '../store/ProjectData';
  import ConditionsSet from '../components/conditionsSet';
  import NumericalSetup from '../components/numerical_setup';
  import editStoryTool from '../components/edit_story_tool.vue';
  import {ComponentName, Methods, CdnLibrary} from '../const/common';

  export default {
    name: 'edit_story_base',
    components: {
      'edit-story-tool': editStoryTool,
      'numerical-setup': NumericalSetup,
      'conditions-set': ConditionsSet

    },
    store,
    data() {
      return {
        shortcut: this.shortcutInit,
        roleData: [],
        moodType: 0,
        commonMethods: Methods,
        malib: new MaLib(this),
        isLoading: false,
        firstId: 0,
        secondId: 0,
        thirdId: 0,
        listId: 0,
        cdnres: CdnLibrary.CDNRES,
        page: 1,
        maCount: 0,
        maData: [],
        dataLoading: false,
        projectData: new ProjectData(this),
        leadingRole: null,
        bgMaLib: ComponentName.IMAGE_LIBRARY,
        bgmMaLib: ComponentName.MUSIC_LIBRARY,
        numericalSwitch: false,
        moodSwitch: this.initMoodSwitch(),
      }
    },
    computed: {
      isShortcutInit() {
        return this.$store.state.isShortcutInit;
      },
      isEditMsgEmoji() {
        return this.shortcut.emoji;
      },
      watchGuideStep1() {
        return this.guideConf.dispose['step1'];
      },
      watchGuideStep2() {
        return this.guideConf.dispose['step2'];
      },
      ...mapState(['parrent', 'useRole', 'moodList', 'roleSite', 'MaLimit', 'visualEdit', 'editText', 'guideConf'])
    },
    methods: {
      initMoodSwitch() {
        return {
          angry: true,
          happy: true,
          normal: true,
          sad: true
        }
      },
      openMaLib(type, hash) {
        this.shortcutInit();
        Methods.openMaLib(type, 'insert');
        Methods.checkChapterHash(hash);
      },
      roleStatus(role, type) {
        let _res = false, condition = null, leadingSign = false;

        switch(type) {
          case 'leading':
            leadingSign = true;
            condition = Methods.getRoleStatus('main');
            break;
          case 'aside':
            condition = Methods.getRoleStatus('sys');
            break;
          case 'costar':
            condition = Methods.getRoleStatus('costar');
            break;
        }
        if (role.characterType === condition) {
          if (leadingSign) {
            this.leadingRole = role;
          }
          _res = true;
        }
        return _res;
      },
      cancelEdit() {
        Middle.MiddleCommand.cancelEdit();
        store.state.setRoleSiteDom = false;
        Methods.checkChapterHash(16);
      },
      loadMore() {
        if (this.page >= Math.ceil(parseInt(this.maCount) / this.MaLimit)) {
          return;
        }
        this.dataLoading = true;
        this.page++;
        this.classifyCut(null, null);
      },
      shortcutInit() {
        this.shortcut = {
          role: false,
          mood: false,
          media: false,
          emoji: false,
          music: false,
          chapterList: false
        };
        store.state.hideStoryInput = false;
        Methods.checkChapterHash(15);
      },
      selectRole(img, role) {
        this.moodType = 0;
        store.state.useRole = {charId: role.id, cover: img, name: role.name, mood: 'normal'};
        Methods.setRoleSite();
        Methods.checkChapterHash(14);
      },
      isOPenshortCut() {
        let res = true;

        for (let i in this.shortcut) {
          if (this.shortcut[i] && i !== 'addRole' && i !== 'chapter') {
            res = false;
          }
        }
        return res;
      },
      setRoleSite(site) {
        store.state.roleSite = site;
        Methods.checkChapterHash(13);
      },
      play(src) {
        audioPlayer.toggle(src);
      },
      setMood(mood, i) {
        this.moodType = i;
        this.useRole.mood = mood;
        this.shortcutInit();
        Methods.checkChapterHash(25);
      },
      getChapterVal() {
        return Middle.MiddleData.getCurrentChapterChatList();
      },
      editWidget(type, hash) {
        if (type === 'mood' && !this.shortcut[type]) {
          if (!!this.useRole.charId) {
            this.moodSwitch = Middle.MiddleData.getCharacterExpression(this.useRole.charId);
          } else {
            this.moodSwitch = this.initMoodSwitch();
          }
        }

        if (type !== 'addRole' || type !== 'mood') {
          if (!this.shortcut[type]) {
            this.shortcutInit();
          }
          this.shortcut[type] = !this.shortcut[type];
        }

        if (type === 'emoji') {
          store.state.hideStoryInput = true;

          this.maData = [];
          this.classifyCut(null, null);
        } else {
          store.state.hideStoryInput = false;
        }
        Methods.multimediaReset();
        store.state.editMsgEmoji = false;
        switch (type) {
          case 'role':
            let _item = null, tmp_role_list = [],
                curData = this.getChapterVal();

            for (let j = 0; j < curData.length; j++) {
              _item = Methods.getCharacter(curData[j].id);
              _item.characterType = curData[j].characterType;
              tmp_role_list.push(_item);
            }
            this.roleData = tmp_role_list;
            if (tmp_role_list.length <= 0) {
              return Toast({
                message: '网络错误，请刷新重试'
              });
            }
            break;
          case 'chapter':
            Methods.cutComponent([ComponentName.CHAPTER_LIST], true);
            break;
          case 'addRole':
            store.state.isChangeChapter = true;
            Methods.setHeaderConf('chapterSet', '返回', ComponentName.EDIT_STORY);
            Methods.cutComponent([ComponentName.CHAPTER_SET], true);
            break;
        }
        Methods.checkChapterHash(hash);
      },
      sendMsg(type, msg, item, hash) {
        Methods.sendTextMsg(type, msg, item)
        Methods.checkChapterHash(hash);
      },
      errorComplete() {},
      classifyCut(id, type) {
        //表情
        let _isLoading = false;

        if (id !== null && type !== null) {
          this.maData = [];
          this.page = 1;
        }
        if (this.maData.length <= 0) {
          _isLoading = true;
        }
        this.malib.setIdByTitleType(id, type);
        this.malib.initTypeData(MaType.EMO_PIC, this.page, function (data) {
          this.maCount = data.data[0].count;

          if (data.data && data.data[0] && data.data[0].data && data.data[0].data[0]) {
            let id = data.data[0].data[0].id;
            this.malib.getGoodDetail(id, function (res) {
              if (parseInt(res.status) <= 0) {
                this.errorComplete();
                return;
              }
              this.maData = this.maData.concat(res.data.data.rs_data);
              this.dataLoading = false;
            }, this.errorComplete, this);
          }
        }, this.errorComplete, this, _isLoading);
      },
      setToolY() {
        // +1 是因为有添加角色的按钮占位
        let rowLength = Math.ceil((this.roleData.length + 1) / 4), size = (document.documentElement.clientWidth / 3.6);

        store.state.guideConf.toolY = ((rowLength + 0.16) * size);
      },
      addDifItem(){
        Middle.MiddleData.initAddDifItems();
        this.shortcutInit();
        Methods.checkChapterHash(20);
      },
      cutSetting(type, res) {
        this.shortcutInit();
        if (type === 'num') {
          store.state.numericalSwitch = res;
          store.state.numericalType = 'add';
        } else if (type === 'condition') {
          store.state.conditionsSwitch = res;
          store.state.conditionsType = 'add';
        }
      },
    },
    watch: {
      isShortcutInit(newVal) {
        if (newVal) {
          this.shortcutInit();
        }
        store.state.isShortcutInit = false;
      },
      isEditMsgEmoji(newVal) {
        if (!newVal) {
          store.state.hideStoryInput = false;
        }
      },
      watchGuideStep1(newVal) {
        if (newVal) {
          this.editWidget('role');
          store.state.guideConf.nowProgress += 1;
          this.setToolY();
        }
      },
      watchGuideStep2(newVal) {
        if (newVal) {
          let role = this.leadingRole, _store = store.state.guideConf;

          this.selectRole(Methods.getRoleCover(role), role);
          _store.nowProgress += 1;
        }
      }

    }
  }
</script>

<style scoped>
  @import "../style/css/edit_story_base.css";
</style>



// WEBPACK FOOTER //
// src/components/edit_story_base.vue